import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * ScrollToTop
 *
 * Resets the window scroll position to the top whenever the pathname changes.
 * React Router does NOT restore scroll by default on client-side navigation,
 * so users landing on a new page can otherwise remain at the previous scroll
 * offset (e.g. clicking a Tax Explorer row → Intake, but staying mid-page).
 *
 * We intentionally scroll only on pathname change (not on query-string change)
 * so that in-page filter interactions do not jump the viewport.
 */
export function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Use instant (auto) scroll rather than smooth — a smooth scroll on a
    // freshly mounted page feels janky and can compete with layout paint.
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname]);

  return null;
}

export default ScrollToTop;
